import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

/** Sends page_view on React Router navigations (SPA). */
export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search + location.hash);
  }, [location]);

  return null;
}
